<template>
  <v-container fluid class="text-right" dir="rtl">
    <v-row align="center" class="mb-2">
      <v-col cols="12" md="6">
        <h3 class="page-title">إدارة المستخدمين</h3>
      </v-col>
      <v-col cols="12" md="6" class="text-left">
        <AddNewUser @user-added="loadUsers" />
      </v-col>
    </v-row>

    <v-alert dense text type="error" v-if="loadError" class="small-text">
      تعذر تحميل قائمة المستخدمين الرجاء اعادة المحاولة
    </v-alert>

    <v-card elevation="0" class="pa-2">
      <v-text-field
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        placeholder="بحث"
        outlined
        dense
        hide-details
        class="mb-4"
      ></v-text-field>

      <v-data-table
        :headers="headers"
        :items="users"
        :search="search"
        :loading="loading"
        loading-text="جاري التحميل..."
        no-data-text="لا توجد بيانات"
        no-results-text="لا توجد نتائج مطابقة"
        class="text-right small-text"
      >
        <template v-slot:[`item.role`]="{ item }">
          {{ roleLabel(item.role) }}
        </template>

        <template v-slot:[`item.is_active`]="{ item }">
          <v-chip small :color="item.is_active ? 'green' : 'grey'" text-color="white">
            {{ item.is_active ? "مفعل" : "غير مفعل" }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AddNewUser from "../../components/Models/Users/AddNewUser.vue";

export default {
  name: "ManageUsers",

  components: { AddNewUser },

  data() {
    return {
      search: "",
      loading: false,
      loadError: false,
      headers: [
        { text: "الاسم", value: "name", align: "right" },
        { text: "اسم المستخدم", value: "username", align: "right" },
        { text: "رقم الموبايل", value: "mobile", align: "right" },
        { text: "الصلاحية", value: "role", align: "right" },
        { text: "الحالة", value: "is_active", align: "right" },
      ],
      roleLabels: {
        admin: "مدير",
        publisher: "ناشر",
        client: "مستخدم",
      },
    };
  },

  computed: {
    ...mapGetters(["allUsersData"]),

    users() {
      return this.allUsersData || [];
    },
  },

  created() {
    this.loadUsers();
  },

  methods: {
    ...mapActions(["fetchUsers"]),

    roleLabel(role) {
      return this.roleLabels[role] || role;
    },

    loadUsers() {
      this.loading = true;
      this.loadError = false;
      this.fetchUsers()
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.loadError = true;
        });
    },
  },
};
</script>

<style scoped>
.page-title {
  color: #0f335f;
}
</style>
